import { Component, Inject, Input } from '@angular/core';
import { firstValueFrom, Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { FrontendDisplayHtmlResourceModel, FrontendDisplayHtmlType } from '../../services/api-services';
import { CoreService_TOKEN } from '../../tokens/injection-tokens';
import { ICoreService } from '../../interfaces/core-service.interface';
import { ValidationHandlerService } from '../../services/validation-handler.service';
import { LanguageService } from '../../services/language.service';
import { LocalStorageWrapper } from '../../classes/local-storage-wrapper.class';
import { ISiteSettings } from '../../interfaces/site-settings.interface';

@Component({
  selector: 'app-html-viewer',
  templateUrl: './html-viewer.component.html',
})
export class HtmlViewerComponent {
    @Input()
    public type: FrontendDisplayHtmlType;
    
    private infoTextHtml: string = '';
    get sanitizedHtml() {
        return this.sanitizer.bypassSecurityTrustHtml(this.infoTextHtml);
    }

    private language: string;
    private subscription: Subscription;

    private isPublicSite: boolean;

    constructor(
        @Inject(CoreService_TOKEN) 
        private coreService: ICoreService,
        private validationHandlerService: ValidationHandlerService,
        private sanitizer: DomSanitizer,
        private languageService: LanguageService
    ) {
        this.isPublicSite = LocalStorageWrapper.getObject<ISiteSettings>('SiteSettings').isPublicSite;
    }

    public ngOnInit() {
        this.subscription = this.languageService.language$.subscribe(value => {
            if (this.language !== value) {
                this.language = value;
                this.getInfoText();
            }
        });

        this.getInfoText();
    }

    public ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    private getInfoText() {
        if (!this.language) {
            this.language = LocalStorageWrapper.getLocale();
        }

        let model: FrontendDisplayHtmlResourceModel = {
            language: this.language,
            type: this.type,
        }
        
        firstValueFrom(this.coreService.getFrontendDisplayHtmlResourceByKey(model))
            .then((res) => {
                this.infoTextHtml = res.result.value;
            })
            .catch((err: HttpErrorResponse) => {
                this.validationHandlerService.handleServerError(err);
            });
    }
}
